var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CAlert',_vm._b({staticClass:"app-banner",on:{"update:show":function($event){return _vm.$emit('update:show', $event)}}},'CAlert',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }